export const swalColors = {
  bgFront: "#FFFFFF",
  bgBack: "#F3F4F6",
  darkBgFront: "#27272A",
  darkBgBack: "#18181B",
  textDark: "#FFFFFF",
  textNormal: "#0C0C0C",
};
